/* Shared react-select v5 theme for V3 admin pages — searchable dropdowns.
   CSS custom properties so it follows the active light/dark theme. */

const v3SelectStyles = {
    container: (base) => ({ ...base, minWidth: 200 }),
    control: (base, state) => ({
        ...base,
        background: 'var(--v3-input-bg, rgba(255,255,255,0.04))',
        borderColor: state.isFocused ? 'var(--v3-accent)' : 'var(--v3-glass-border)',
        borderRadius: 10,
        minHeight: 38,
        boxShadow: 'none',
        fontSize: 13,
        ':hover': { borderColor: state.isFocused ? 'var(--v3-accent)' : 'var(--v3-glass-highlight)' },
    }),
    menu: (base) => ({
        ...base,
        background: 'var(--v3-bg-elevated)',
        border: '1px solid var(--v3-glass-border)',
        borderRadius: 10,
        overflow: 'hidden',
        zIndex: 30,
    }),
    menuList: (base) => ({ ...base, padding: 4 }),
    // Portalled to <body> to escape ancestor overflow:hidden (hero/card clip).
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (base, state) => ({
        ...base,
        background: state.isSelected
            ? 'var(--v3-bg-surface)'
            : state.isFocused ? 'var(--v3-bg-surface)' : 'transparent',
        color: 'var(--v3-text-primary)',
        borderRadius: 8,
        fontSize: 13,
        cursor: 'pointer',
    }),
    singleValue: (base) => ({ ...base, color: 'var(--v3-text-primary)' }),
    placeholder: (base) => ({ ...base, color: 'var(--v3-text-muted)' }),
    input: (base) => ({ ...base, color: 'var(--v3-text-primary)' }),
    dropdownIndicator: (base) => ({ ...base, color: 'var(--v3-text-muted)', padding: 6 }),
    clearIndicator: (base) => ({ ...base, color: 'var(--v3-text-muted)', padding: 6 }),
    indicatorSeparator: (base) => ({ ...base, background: 'var(--v3-glass-border)' }),
};

export default v3SelectStyles;
